import React from "react";
import {
  Row,
  Col,
  Typography,
  Space,
  Image,
  Collapse,
} from "../../common/utils/antd-imports/AntdImports";
import { DownOutlined, LinkedinFilled, UpOutlined } from "@ant-design/icons";
import AMPlogo from "../../../assests/ampw-svg.svg";
import "./Footer.css"; // Import the CSS file
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { resetBreadcrumbs } from "../../../store/slices/common-slice/bread-crumbs/BreadCrumbSlice";
import { useDispatch } from "react-redux";

const { Text, Title } = Typography;
const presentYear = new Date().getFullYear();
const FooterSection = ({ SetAdvertise }) => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const goToSubPage = ({ title, path }) => {
    dispatch(resetBreadcrumbs({ title, path }));
  };

  return (
    <>
      {isMobile ? (
        <div className="footer">
          <Row>
            <Col span={8} className="footer-col">
              <Image
                height={28}
                width={136}
                src={AMPlogo}
                preview={false}
                alt=""
              ></Image>
            </Col>
          </Row>

          <hr className="footer-hr" />
          <Row>
            <Collapse
              className="collapse-container footer-collapse-container"
              expandIcon={({ isActive }) =>
                isActive ? (
                  <UpOutlined style={{ color: "white" }} />
                ) : (
                  <DownOutlined style={{ color: "white" }} />
                )
              }
              expandIconPosition="end"
              items={[
                {
                  key: "1",
                  label: <span style={{ color: "#fff" }}>Quick Links</span>,
                  children: (
                    <div>
                      <Space
                        direction="vertical"
                        size={20}
                        className="footer-links"
                      >
                        <NavLink to="/" passHref className="home-page-hover">
                          <Text style={{ fontFamily: "Roboto" }}>Home</Text>
                        </NavLink>
                        <NavLink to="/products" passHref>
                          <Text className="home-page-hover">Shop</Text>
                        </NavLink>
                        <NavLink
                          passHref
                          onClick={() =>
                            setTimeout(() => {
                              navigate("/home", {
                                state: {
                                  navigatedLink: "how-it-works",
                                },
                              });
                            }, 200)
                          }
                        >
                          <Text className="home-page-hover">
                            <Text className="home-page-hover">
                              How It Works
                            </Text>
                          </Text>
                        </NavLink>
                        <NavLink to="/about" passHref>
                          <Text>About Us</Text>
                        </NavLink>
                      </Space>
                    </div>
                  ),
                },
              ]}
            ></Collapse>
          </Row>
          <hr className="footer-hr" />
          <Row>
            <Collapse
              className="footer-collapse-container"
              style={{ color: "red" }}
              expandIcon={({ isActive }) =>
                isActive ? (
                  <UpOutlined style={{ color: "white" }} />
                ) : (
                  <DownOutlined style={{ color: "white" }} />
                )
              }
              expandIconPosition="end"
              items={[
                {
                  key: "1",
                  label: <span style={{ color: "#fff" }}>Support & Legal</span>,
                  children: (
                    <div>
                      <Space
                        direction="vertical"
                        size={20}
                        className="footer-links"
                      >
                        <NavLink to="/contact" className="home-page-hover">
                          <Text className="home-page-hover"> Contact</Text>
                        </NavLink>
                        <NavLink
                          onClick={() => {
                            setTimeout(() => {
                              navigate("/home", {
                                state: {
                                  navigatedLink: "frequently-asked-questions",
                                },
                              });
                            }, 200);
                          }}
                        >
                          <Text className="home-page-hover"> FAQs</Text>
                        </NavLink>

                        <NavLink to="/privacy-policy">
                          <Text className="home-page-hover">
                            {" "}
                            Privacy Policy
                          </Text>
                        </NavLink>
                        <NavLink
                          onClick={(e) => {
                            e.preventDefault();
                            SetAdvertise(true);
                          }}
                          className="home-page-hover"
                        >
                          <Text className="home-page-hover">
                            {" "}
                            Advertise With AMP
                          </Text>
                        </NavLink>
                      </Space>
                    </div>
                  ),
                },
              ]}
            ></Collapse>
          </Row>
          <hr className="footer-hr" />
          <Row justify="center" style={{ textAlign: "center" }}>
            <Space direction="vertical">
              <a
                href="mailto:info@advertisingmarketplace.com"
                style={{ textDecoration: "none" }}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Text className="footer-contact" style={{ color: "#FFF" }}>
                  info@advertisingmarketplace.com
                </Text>
              </a>
            </Space>
          </Row>
          <Row justify="center">
            <Col>
              {" "}
              <Link to="https://www.linkedin.com/company/advertising-marketplace/">
                <Text className="footer-contact" style={{ color: "#FFF" }}>
                  {" "}
                  LinkedIn
                </Text>
              </Link>
            </Col>
          </Row>
          <Row justify="center" className="footer-bottom">
            <Text style={{ color: "#FFF" }}>
              ©{presentYear} ADVERTISING MARKETPLACE. ALL RIGHTS RESERVED.
            </Text>
          </Row>
        </div>
      ) : (
        <div className="footer">
          <div className="footer-section">
            <Row justify="space-between">
              {/* Logo Section */}
              <Col span={8} className="footer-space-between">
                <Image src={AMPlogo} alt="AMP-Logo" preview={false}></Image>
              </Col>

              <Col span={14}>
                {/* Quick Links */}
                <Row>
                  <Col span={6}>
                    <Title level={5} className="footer-title">
                      QUICK LINKS
                    </Title>
                  </Col>
                  <Col span={7}>
                    <Title level={5} className="footer-title">
                      SUPPORT & LEGAL
                    </Title>
                  </Col>
                  <Col span={7}>
                    <Title level={5} className="footer-title">
                      STAY CONNECTED
                    </Title>
                  </Col>
                </Row>
                <Row>
                  <Col span={6}>
                    <div className="footer-links">
                      <NavLink to="/" className="home-page-hover">
                        <Text style={{ fontFamily: "Roboto" }}>Home</Text>
                      </NavLink>
                      <Text
                        onClick={() => {
                          goToSubPage({ title: "Shop", path: "/products" });
                          navigate("/products");
                        }}
                        className="footer-links-text"
                      >
                        Shop
                      </Text>
                      {/* <Text
                        onClick={() => {
                          navigate("/home", {
                            state: {
                              navigatedLink: "how-it-works",
                            },
                          });
                        }}
                        className="home-page-hover"
                      >
                        How It Works
                      </Text> */}
                      <NavLink
                        to="/about"
                        onClick={() => {
                          goToSubPage({ title: "About US", path: "/about" });
                        }}
                      >
                        <Text style={{ fontFamily: "Roboto" }}>About Us</Text>
                      </NavLink>
                    </div>
                  </Col>
                  {/* Support & Legal */}
                  <Col span={7}>
                    <div
                      direction="vertical"
                      size={20}
                      className="footer-links"
                    >
                      <NavLink
                        to="/contact"
                        onClick={() =>
                          goToSubPage({ title: "Contact", path: "/contact" })
                        }
                      >
                        <Text style={{ fontFamily: "Roboto" }}> Contact</Text>
                      </NavLink>
                      <Text
                        className="home-page-hover"
                        onClick={() =>
                          navigate("/home", {
                            state: {
                              navigatedLink: "frequently-asked-questions",
                            },
                          })
                        }
                      >
                        FAQs
                      </Text>
                      <div
                        onClick={() => {
                          goToSubPage({
                            title: "Privacy Policy",
                            path: "/privacy-policy",
                          });
                          navigate("/privacy-policy");
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <span className="home-page-hover">Privacy Policy</span>
                      </div>

                      <NavLink
                        onClick={(e) => {
                          e.preventDefault();
                          SetAdvertise(true);
                        }}
                        className="home-page-hover"
                      >
                        <Text className="home-page-hover">
                          {" "}
                          Advertise With AMP
                        </Text>
                      </NavLink>
                    </div>
                  </Col>
                  {/* Stay Connected */}
                  <Col span={9}>
                    <Space size="middle" className="footer-icons">
                      <a
                        href="https://www.linkedin.com/company/advertising-marketplace/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <LinkedinFilled />
                      </a>
                    </Space>
                    <div className="footer-contact">
                      <a
                        href="mailto:info@advertisingmarketplace.com?subject=Inquiry&body=Hello%2C%20I%20would%20like%20to%20ask%20about..."
                        style={{ textDecoration: "none" }}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Text className="footer-contact-text">
                          info@advertisingmarketplace.com
                        </Text>
                      </a>
                      <br />
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>

          <Row justify="center" className="footer-bottom">
            <Text style={{ color: "#FFF" }}>
              ©{presentYear} ADVERTISING MARKETPLACE. ALL RIGHTS RESERVED.
            </Text>
          </Row>
        </div>
      )}
    </>
  );
};

export default FooterSection;
